import { render, staticRenderFns } from "./modemboard.vue?vue&type=template&id=11c2f5c8&scoped=true&"
import script from "./modemboard.vue?vue&type=script&lang=js&"
export * from "./modemboard.vue?vue&type=script&lang=js&"
import style0 from "./modemboard.vue?vue&type=style&index=0&id=11c2f5c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c2f5c8",
  null
  
)

export default component.exports